import { navigateTo, useRoute } from 'nuxt/app'
import { onMounted } from 'vue'
import { TRedirect } from '~/types/response-types'
import { useRedirect } from '~/composables/useRedirect'
import { useUser } from '~/composables/useUser'

// this is where we load the page data based on props.collection and an optional filter
export const useRoutingLogic = (data, pending, error) => {
  const user = useUser()
  const route = useRoute()

  // deal with errors & authentication requirements
  if ((error.value && !pending.value) || !data.value) {
    onMounted(async () => {
      await user.logout()
    })
    // // 401: unauthorized (you're not allowed to view the page because it's not published, or because the site isn't live yet.)
    if (error.value?.statusCode === 401) {
      navigateTo(
                `/authenticate?redirect=${encodeURI(route.path)}&error=${
                    error.value?.statusCode
                }: ${error.value?.statusMessage}`,
                {
                  redirectCode: error.value?.statusCode,
                  external: false,
                  replace: true
                }
      )
    } else {
      // else show the error page
      throw createError({
        statusCode: error.value?.statusCode,
        statusMessage: error.value?.statusMessage,
        fatal: true
      })
    }
  } else if (data.value) {
    // check if the returned data is a redirect
    useRedirect(data.value as TRedirect)
  }
}
